module.exports = __webpack_public_path__ + "bin/d8d99fe26d156afaf884ff75f2222009.jpg";